import React from "react";
import { Wrapper } from "./Divider.style";

var Divider = _ref => {
  var { className, orientation = "horizontal" } = _ref;
  return /*#__PURE__*/ React.createElement(Wrapper, {
    className: className,
    orientation: orientation
  });
};

export default Divider;
